import React, { useState, useEffect } from "react";
import "./Blogs.css";
import { useNavigate } from "react-router-dom";
import Common_Blog_Card from "../../components/common-components/common_blog_card/Common_Blog_Card";
import { IDS } from "../../utils/common";
import { Blog, BlogById } from "../../utils/apis/blog/Blog";

const Blogs = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);

  const blogsPerPage = 12;

  const handleBlogClick = (blog) => {
    navigate(`/blog/${blog.id}`, {
      state: blog,
    });
  };

  const blogData = [
    {
      id: 1,
      image: "/assets/images/home/nutricos_banner/img1.webp",
      title: "Tomato Nutrition Guide for Healthy Growth",
      date: "2 hrs ago",
    },
    {
      id: 2,
      image: "/assets/images/blogs/vegetable.jpeg",
      title: "Best Fertilizers for Vegetable Crops",
      date: "1 day ago",
    },
    {
      id: 3,
      image: "/assets/images/factory/img4.jpeg",
      title:
        "Plant Disease Guide: Identifying, Preventing & Managing Common Crop Diseases",
      date: "25/01/2026",
    },

    // ...Keep the remaining blog objects exactly as they are
  ];

  const [banner, setBanner] = useState([]);

  const getBanner = async () => {
    const res = await Blog();
    if (res?.success) setBanner(res.data);
  };

  useEffect(() => {
    getBanner();
  }, []);

  const totalPages = Math.ceil(banner.length / blogsPerPage);
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = banner.slice(indexOfFirstBlog, indexOfLastBlog);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      handlePageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      handlePageChange(currentPage + 1);
    }
  };

  return (
    <section className="Blogs About_Banner">
      <div className="container">
        {/* <div className="About_Banner_holder" onClick={() => navigate("/")}>
          <h5 className="about_us">Back</h5>
        </div> */}

        <div className="blog_cards_section">
          <div className="row">
            {currentBlogs.map((blog) => (
              <Common_Blog_Card
                key={blog.id}
                blog={blog}
                handleBlogClick={handleBlogClick}
              />
            ))}
          </div>

          {totalPages > 0 && (
            <div className="pagination_wrapper">
              <button
                className="page_btn arrow_btn"
                onClick={handlePrev}
                disabled={currentPage === 1}
              >
                &#8249;
              </button>

              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index}
                  className={`page_btn ${
                    currentPage === index + 1 ? "active" : ""
                  }`}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </button>
              ))}

              <button
                className="page_btn arrow_btn"
                onClick={handleNext}
                disabled={currentPage === totalPages}
              >
                &#8250;
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Blogs;
